import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { SignIn, User } from '@phosphor-icons/react';

export const Login = () => {
  const navigate = useNavigate();
  const { login, register } = useAuth();
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [role, setRole] = useState('estimator');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (isLogin) {
      const result = await login(email, password);
      if (result.success) {
        navigate('/dashboard');
      } else {
        setError(result.error);
      }
    } else {
      const result = await register(email, password, name, role);
      if (result.success) {
        navigate('/dashboard');
      } else {
        setError(result.error);
      }
    }

    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-zinc-50 via-white to-zinc-100 px-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <img src="/assets/sg-decor-logo.png" alt="SG Decor" className="h-14" data-testid="login-logo" />
        </div>

        {/* Card */}
        <div className="bg-white border border-zinc-200 rounded-xl p-8 shadow-sm">
          <div className="mb-6 text-center">
            <h1 className="text-2xl font-bold text-zinc-900">
              {isLogin ? 'Sign In' : 'Create Account'}
            </h1>
            <p className="text-sm text-zinc-500 mt-1">
              Turnkey Interior Execution System
            </p>
          </div>

          {error && (
            <div
              className="mb-4 p-3 bg-red-50 border border-red-200 text-red-700 text-sm rounded-lg"
              data-testid="error-message"
            >
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            {!isLogin && (
              <div>
                <Label htmlFor="name" className="text-xs font-semibold text-zinc-500">
                  Full Name
                </Label>
                <Input
                  id="name"
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                  className="mt-1.5 bg-zinc-50 border-zinc-200 rounded-lg"
                  data-testid="name-input"
                />
              </div>
            )}

            <div>
              <Label htmlFor="email" className="text-xs font-semibold text-zinc-500">
                Email
              </Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="mt-1.5 bg-zinc-50 border-zinc-200 rounded-lg"
                data-testid="email-input"
              />
            </div>

            <div>
              <Label htmlFor="password" className="text-xs font-semibold text-zinc-500">
                Password
              </Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="mt-1.5 bg-zinc-50 border-zinc-200 rounded-lg"
                data-testid="password-input"
              />
            </div>

            {!isLogin && (
              <div>
                <Label htmlFor="role" className="text-xs font-semibold text-zinc-500">
                  Role
                </Label>
                <select
                  id="role"
                  value={role}
                  onChange={(e) => setRole(e.target.value)}
                  className="mt-1.5 w-full bg-zinc-50 border border-zinc-200 rounded-lg p-2.5 text-sm"
                  data-testid="role-select"
                >
                  <option value="estimator">Estimator</option>
                  <option value="viewer">Viewer</option>
                  <option value="admin">Admin</option>
                </select>
              </div>
            )}

            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-[#1e3a5f] hover:bg-[#152d4a] text-white rounded-lg py-5 font-medium text-sm transition-colors"
              data-testid="submit-button"
            >
              {loading ? (
                'Processing...'
              ) : isLogin ? (
                <>
                  <SignIn className="mr-2" size={18} />
                  Sign In
                </>
              ) : (
                <>
                  <User className="mr-2" size={18} />
                  Create Account
                </>
              )}
            </Button>
          </form>

          <div className="mt-5 text-center">
            <button
              onClick={() => {
                setIsLogin(!isLogin);
                setError('');
              }}
              className="text-xs text-[#1e3a5f] hover:text-[#152d4a] font-medium"
              data-testid="toggle-auth-mode"
            >
              {isLogin
                ? "Don't have an account? Register"
                : 'Already have an account? Sign In'}
            </button>
          </div>
        </div>

        <p className="text-center text-[10px] text-zinc-400 mt-6">SG Decor Pvt. Ltd.</p>
      </div>
    </div>
  );
};
